import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assist-left',
  templateUrl: './assist-left.component.html',
  styleUrls: ['./assist-left.component.scss'],
})
export class AssistLeftComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
